import { useCallback } from 'react';

import { useValueHandle } from '../../hook/useValueHandle';
import { DateInput, DateInputProps } from '../DateInput';
import { FloatingLabelBox } from '../FloatingLabelBox';

interface FloatInputProps extends DateInputProps {
  required?: boolean;
}

export function FloatDateInput({
  placeholder,
  onFocus,
  onBlur,
  onChange,
  value,
  defaultValue,
  style,
  size,
  required,
  ...restProps
}: FloatInputProps) {
  const { hasValue, handleChange, handleBlur, handleFocus, isFocus } =
    useValueHandle({
      id: restProps.id,
      defaultValue,
      value,
      onFocus,
      onBlur,
    });

  const changeHandler = useCallback<React.ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      handleChange(e.target.value);
      if (onChange) {
        onChange(e);
      }
    },
    [onChange]
  );

  return (
    <FloatingLabelBox
      label={placeholder}
      focused={isFocus}
      haveValue={hasValue}
      width={style?.width}
      height={style?.height}
      required={required}
      status={
        restProps.status || (restProps['aria-invalid'] ? 'error' : undefined)
      }
    >
      <DateInput
        style={style}
        className="w-full border-none py-2"
        variant="borderless"
        {...restProps}
        onFocus={handleFocus}
        onBlur={handleBlur}
        value={value}
        defaultValue={defaultValue}
        onChange={changeHandler}
        size={size}
      />
    </FloatingLabelBox>
  );
}
